
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
//    if (Flits.request.page_type == 'cart' || Flits.request.page_type == 'index') {
//     if(Flits.Metafields.IS_STORE_CREDIT_PAID && Flits.Metafields.is_store_credit_enable && window.flitsObjects.storeData.customer_id != -1){
//       Flits.LoadStyleScript('cartJs',window.flitsObjects.allCssJs.cartJs.custom_url);
//     }
//   }

  
  

  
//   Flits(document).on('Flits:Navigation:Loaded', function(event){
//   var flitscaretIcon ='<svg class="flits-nav-caret-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 284.929 284.929" style="enable-background:new 0 0 284.929 284.929;" xml:space="preserve" class=""><g><g> <path d="M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441   L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082   c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647   c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#FFFFFF"/> </g></g> </svg>';          
//  var flitsInfoIcon =  '<span class="flits-span-svg"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 0C4.93429 0 0 4.93429 0 11C0 17.0657 4.93429 22 11 22C17.0657 22 22 17.0657 22 11C22 4.93429 17.0657 0 11 0ZM11 1.57143C16.2161 1.57143 20.4286 5.78386 20.4286 11C20.4286 16.2161 16.2161 20.4286 11 20.4286C5.78386 20.4286 1.57143 16.2161 1.57143 11C1.57143 5.78386 5.78386 1.57143 11 1.57143Z" fill="black"/><path d="M11 1C16.5323 1 21 5.46773 21 11C21 16.5323 16.5323 21 11 21C5.46773 21 1 16.5323 1 11C1 5.46773 5.46773 1 11 1Z" fill="black"/><path d="M10.9837 9.00016C10.4325 9.00888 9.99258 9.46123 10.0001 10.0108V16.9893C9.99635 17.256 10.1001 17.5127 10.2876 17.7034C10.475 17.8928 10.7325 18 11 18C11.2675 18 11.5237 17.8928 11.7112 17.7034C11.8999 17.5127 12.0037 17.256 11.9999 16.9893V10.0108C12.0037 9.74164 11.8974 9.48117 11.7062 9.29177C11.515 9.10111 11.2537 8.99517 10.9837 9.00016Z" fill="#F8F8F8"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12 5C12 6.33333 10 6.33333 10 5C10 3.66667 12 3.66667 12 5Z" fill="#F8F8F8"/></svg></span>'; 
//     var settings = event.detail.settings;     
//     settings['navs'].push({
//       title: Flits.t("Flits.locals.navigation.store_page", "Store Page"),
//       url:'',
//       target:0,
//       menuClass:null,
//       badge: null,
//       icon: flitsInfoIcon+flitscaretIcon,
//       isShow: 1,
//       loader:null,
//       body_html: ""
//     });
//   });
  
  Flits(document).on('Flits:Navigation:Loaded', function(event){
    
    if(window.flits_route_account_url == '/de/account'){
      var deurl = 'https://mysecretcase.zendesk.com/hc/de';
    }
    else if(window.flits_route_account_url == '/en/account'){
      var deurl = 'https://mysecretcase.zendesk.com/hc/en-150';
    }
    else if(window.flits_route_account_url == '/fr/account'){
      var deurl = 'https://mysecretcase.zendesk.com/hc/fr';
    }else{
      var deurl = 'https://mysecretcase.zendesk.com/hc';
    }
    var settings = event.detail.settings;
    var flitscaretIcon ='<svg class="flits-nav-caret-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 284.929 284.929" style="enable-background:new 0 0 284.929 284.929;" xml:space="preserve" class=""><g><g> <path d="M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441   L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082   c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647   c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#FFFFFF"/> </g></g> </svg>';          
    var obj = {
      title: Flits.t("Flits.locals.navigation.assistenza_clienti", "Customer service"),
      url:deurl,
      target:0,
      badge: null,
      icon: '<span class="flits-span-svg"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 0C4.93429 0 0 4.93429 0 11C0 17.0657 4.93429 22 11 22C17.0657 22 22 17.0657 22 11C22 4.93429 17.0657 0 11 0ZM11 1.57143C16.2161 1.57143 20.4286 5.78386 20.4286 11C20.4286 16.2161 16.2161 20.4286 11 20.4286C5.78386 20.4286 1.57143 16.2161 1.57143 11C1.57143 5.78386 5.78386 1.57143 11 1.57143Z" fill="black"/><path d="M11 1C16.5323 1 21 5.46773 21 11C21 16.5323 16.5323 21 11 21C5.46773 21 1 16.5323 1 11C1 5.46773 5.46773 1 11 1Z" fill="black"/><path d="M10.9837 9.00016C10.4325 9.00888 9.99258 9.46123 10.0001 10.0108V16.9893C9.99635 17.256 10.1001 17.5127 10.2876 17.7034C10.475 17.8928 10.7325 18 11 18C11.2675 18 11.5237 17.8928 11.7112 17.7034C11.8999 17.5127 12.0037 17.256 11.9999 16.9893V10.0108C12.0037 9.74164 11.8974 9.48117 11.7062 9.29177C11.515 9.10111 11.2537 8.99517 10.9837 9.00016Z" fill="#F8F8F8"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12 5C12 6.33333 10 6.33333 10 5C10 3.66667 12 3.66667 12 5Z" fill="#F8F8F8"/></svg></span>'+flitscaretIcon,
      isShow: 1,
      loader:null,
      body_html: '<div class="flits-custom-content"></div>'
    }
    settings.navs.splice(12, 0, obj);
    
    var objWishlist = {
      title: "Wishlist",
      url: "/pages/wishlist",
      target: 0,
      badge: null,
      icon: '<span class="flits-span-svg"><svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_249:4729)"><path d="M5.86777 8.62161e-05C4.36425 8.62161e-05 2.85634 0.571417 1.71351 1.71857C-0.572865 4.01173 -0.569476 7.72872 1.71351 10.0231L10.3748 18.7413C10.5388 18.9067 10.7617 19 10.9947 19C11.2289 19 11.4518 18.9067 11.6147 18.7413C14.5063 15.8409 17.3934 12.9414 20.2852 10.0409C22.5716 7.74778 22.5716 4.02071 20.2852 1.7275C17.9988 -0.56566 14.2722 -0.56566 11.986 1.7275L10.9995 2.70818L10.013 1.71848C8.87037 0.571331 7.37114 8.62161e-05 5.86777 8.62161e-05ZM5.86777 1.70956C6.91876 1.70956 7.96749 2.11557 8.78189 2.93318L10.3838 4.55268C10.5479 4.71801 10.7707 4.81136 11.0038 4.81136C11.2379 4.81136 11.4608 4.71801 11.6237 4.55268L13.2166 2.95118C14.8457 1.31593 17.425 1.31593 19.0541 2.95118C20.6832 4.58643 20.6832 7.18204 19.0541 8.81737C16.3695 11.5098 13.6838 14.2134 10.9993 16.906L2.9445 8.80844C1.31653 7.17095 1.3154 4.56751 2.9445 2.93333C3.75904 2.11572 4.81669 1.70956 5.86777 1.70956Z" fill="black"></path><path d="M5.86777 1.70956C6.91876 1.70956 7.96749 2.11557 8.78189 2.93318L10.3838 4.55268C10.5479 4.71801 10.7707 4.81136 11.0038 4.81136C11.2379 4.81136 11.4608 4.71801 11.6237 4.55268L13.2166 2.95118C14.8457 1.31593 17.425 1.31593 19.0541 2.95118C20.6832 4.58643 20.6832 7.18204 19.0541 8.81737C16.3695 11.5098 13.6838 14.2134 10.9993 16.906L2.9445 8.80844C1.31653 7.17095 1.3154 4.56751 2.9445 2.93333C3.75904 2.11572 4.81669 1.70956 5.86777 1.70956Z" fill="black"></path></g><defs><clipPath id="clip0_249:4729"><rect width="22" height="19" fill="white"></rect></clipPath></defs></svg></span>'+flitscaretIcon,
      isShow: 1,
      loader: null,
      body_html: '<div class="flits-custom-content"></div>'
    }
    settings.navs.splice(13, 0, objWishlist);
  });
  
  Flits(document).on('Flits:Navigation:Loaded', function(event){
    var settings = event.detail.settings;
        var flitscaretIconProf ='<svg class="flits-nav-caret-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 284.929 284.929" style="enable-background:new 0 0 284.929 284.929;" xml:space="preserve" class=""><g><g> <path d="M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441   L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082   c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647   c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#FFFFFF"/> </g></g> </svg>';          

    var obj_prof = {
      title: Flits.t("Flits.locals.navigation.profile", "My Profile"),
      url:'#profile',
      target:0,
      badge: null,
      icon: '<span class="flits-span-svg"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.24122 22.0383C2.17874 19.862 5.75439 16.3057 10.2965 15.9171C10.7432 15.8789 11.1081 15.519 11.1081 15.0707C11.1081 14.7733 10.9448 14.5025 10.6933 14.3438C9.44062 13.5535 7.54054 11.9096 7.54054 10.0589V5.5294C7.54054 4.23695 9.3195 1.00862 12.2852 1.00002C11.9831 1.00002 11.5282 1 12.321 1C12.3134 1 12.3055 1 12.2973 1C12.2933 1 12.2893 1.00001 12.2852 1.00002C12.4764 1.00002 12.6064 1.00001 12.321 1C11.5282 1 11.9831 1.00002 12.2852 1.00002C12.2893 1.00001 12.2933 1 12.2973 1H12.8919C14.0811 1.00017 17.0541 2.81176 17.0541 4.88234V10.0589C17.0541 11.2645 16.022 13.0316 13.9579 14.314C13.6725 14.4913 13.4865 14.7974 13.4865 15.1334C13.4865 15.5693 13.7921 15.9427 14.2152 16.0478C17.24 16.7998 22.0434 18.761 22.8753 22.0098C23.0123 22.5448 22.5523 23 22 23H2C1.44772 23 1.02271 22.5455 1.24122 22.0383Z" fill="black"></path><path d="M7.54054 10.0589C7.54054 11.9096 9.44062 13.5535 10.6933 14.3438C10.9448 14.5025 11.1081 14.7733 11.1081 15.0707V15.0707C11.1081 15.519 10.7432 15.8789 10.2965 15.9171C5.75439 16.3057 2.17874 19.862 1.24122 22.0383C1.02271 22.5455 1.44772 23 2 23H22C22.5523 23 23.0123 22.5448 22.8753 22.0098C22.0434 18.761 17.24 16.7998 14.2152 16.0478C13.7921 15.9427 13.4865 15.5693 13.4865 15.1334V15.1334C13.4865 14.7974 13.6725 14.4913 13.9579 14.314C16.022 13.0316 17.0541 11.2645 17.0541 10.0589V4.88234C17.0541 2.81176 14.0811 1.00017 12.8919 1M7.54054 10.0589C7.54054 7.98829 7.54054 6.60782 7.54054 5.5294M7.54054 10.0589V5.5294M7.54054 5.5294C7.54054 4.2352 9.32432 0.999871 12.2973 1M12.2973 1C13.1892 1.00004 10.5135 1 12.8919 1M12.2973 1H12.8919" stroke="black"></path></svg></span>'+ flitscaretIconProf,
      isShow: 1,
      loader:null,
      body_html: ''
    }
    settings.navs.splice(0, 1, obj_prof);
  });
  
  Flits(document).on('Flits:Navigation:Loaded', function(event){
    setInterval(function(){
     Flits.t("Flits.locals.navigation.profile", "My Profile");
    },0);
       
  });
  
  Flits(document).on('Flits:AccountPage:Loaded', function(event){ 
    setTimeout(function(){
      var data = event.detail;
      Flits.shopCountryName = 'Italy';
     
    },2000); 
  });
  Flits(document).on('Flits:getShopifyProductData:complete', function(event){ 
    setTimeout(function(){
        Flits('select.flits-variant-select option:nth-child(2)').attr('selected', 'selected');
    },2000); 
  }); 
  
//   Flits(document).on('Flits:Navigation:Loaded', function(event){
//     var settings = event.detail.settings;
//     var wishlistObj = {
//                         title: Flits.t("Flits.locals.navigation.wishlist", "My Wishlist"),
//                         url: "#wishlist",
//                         target: 0,
//                         menuClass: null,
//                         badge: '<span class="flits-menu-badge flits-badge flits-wishlist-badge flits-menu-badge-hide">0</span>',
//                         icon:
//                             '<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 18.45 16"><path id="Layer_2" data-name="Layer 2" d="M17.57,2.16A4.72,4.72,0,0,0,13.86,0h0c-2,0-3.77,1.52-4.58,2.36C8.42,1.52,6.67,0,4.65,0H4.6A4.72,4.72,0,0,0,.87,2.18a5.1,5.1,0,0,0,.65,6.48L8.8,15.82a.6.6,0,0,0,.85,0h0l7.27-7.16A5.1,5.1,0,0,0,17.57,2.16Zm-1.5,5.62L9.23,14.52,2.39,7.78A3.84,3.84,0,0,1,1.87,2.9,3.57,3.57,0,0,1,4.61,1.23h0c2.14,0,4.08,2.42,4.1,2.44a.64.64,0,0,0,.9.07l.06-.07s2-2.49,4.13-2.44a3.55,3.55,0,0,1,2.73,1.64A3.85,3.85,0,0,1,16,7.78Z" transform="translate(0)" /></svg>',
//                         isShow: Flits.Metafields.IS_WISHLIST_PAID && Flits.Metafields.IS_WISHLIST_ENABLE,
//                         loader: { desktop_class: null, mobile_class: null },
//                         body_html: null,
//                     }
//     settings.navs.splice(3, 0,  wishlistObj);
//   });
    
   Flits(document).on('Flits:profileTemplate:Loaded', function(event){ 
    var data = event.detail;
    Flits.shopCountryName = 'Italy'
  });

  
   function phoneWithContryCustom() {
            let numberDetails;
            let countryIndex;
            let onlyNumber;
            let areaCode;
            if (Flits('#flits-form-profile .flits-input[name="phone"]').val())
                (numberDetails = new libphonenumber.parsePhoneNumber(Flits('#flits-form-profile .flits-input[name="phone"]').val())),
                    (countryIndex = Flits('.flits-profile-phone-with-country-div .flits-country-drpdown select option[data-country-iso-code="' + numberDetails.country + '"]').val()),
                    (areaCode = Flits('.flits-profile-phone-with-country-div .flits-country-drpdown select option[data-country-iso-code="' + numberDetails.country + '"]').attr("data-country-code")),
                    (onlyNumber = numberDetails.number.replace(areaCode, "")),
                    Flits(".flits-profile-phone-with-country-div .flits-country-drpdown select").val(countryIndex),
                    Flits('#flits-form-profile .flits-input[name="phone"]').val(onlyNumber);
            else if (((Flits.shopCountryName = Flits.shopCountryName.replace("&amp;", "&")), Flits('.flits-profile-phone-with-country-div .flits-country-drpdown select option[data-country-name="' + Flits.shopCountryName + '"]')))
                (countryIndex = Flits('.flits-profile-phone-with-country-div .flits-country-drpdown select option[data-country-name="' + Flits.shopCountryName + '"]').val()),
                    Flits(".flits-profile-phone-with-country-div .flits-country-drpdown select").val(countryIndex);
            else {
                let defualtCountry = Flits.defualtCountry;
                (countryIndex = Flits('.flits-profile-phone-with-country-div .flits-country-drpdown select option[data-country-iso-code="' + defualtCountry + '"]').val()),
                    Flits(".flits-profile-phone-with-country-div .flits-country-drpdown select").val(countryIndex);
            }
            Flits(".flits-profile-phone-with-country-div .flits-country-drpdown select").trigger("change");
        }
  
  Flits(window).on('Flits:myProfile:Loaded', function(event){ 
    Flits.each(Flits.setPhoneCountryCode.settings.countryOptionArr, function (key, value) {
      Flits(".flits-profile-phone-with-country-div .flits-country-drpdown select").append(value.clone());
    });
    Flits.shopCountryName = 'Italy';
    Flits("#flits-form-profile").removeClass("flits-read-input");
    Flits(".flits-profile-save-button").parents().removeClass("flits-d-none");
    Flits(".flits-profile-edit-button").addClass("flits-d-none");
    Flits("#flits-form-profile .flits-input").attr("readonly", !1);
    Flits('#flits-form-profile .flits-input[name="email"]').attr("readonly", !0);
    Flits('#flits-form-profile .flits-input[name="birthdate"]').attr("type", "date");
    Flits('#flits-form-profile .flits-input[name="referby"]').attr("readonly", !0);
    Flits("#flits-form-profile select.flits-input").attr("disabled", !1);
    Flits(".flits-profile-phone-with-country-div").removeClass("flits-readonly-mode");
    phoneWithContryCustom();
    
  });
  
  Flits( window ).load(function() {
    setTimeout(function(){ 
      Flits('.filts-wishlist-product-style.flits-wishlist-button-style').css('opacity','1');
    }, 1500);   
  });
  
  
  function flitsCustomIntregation(){
    var integrated_page =Flits(".flits-custom-page").find(".page-blocks").parent();
    Flits("#flits_tab_assistenza-clienti").append(integrated_page);
    Flits(".flits-custom-page").remove();
  }

  Flits(document).on('Flits:AccountPage:Loaded', function(event){  
    setTimeout(function(){
     flitsCustomIntregation();
    },2000);
        
  });
  
   

//      window.flitswishlistResponse = {};
//   Flits(document).on('Flits:Wishlist:AjaxSuccessful',function(event){
//     var data = event.detail;
//     window.flitswishlistResponse = data.resp;
//   });
//   Flits(document).on('Flits:getShopifyProductData:complete',function(event){
//     var data = event.detail;
//     if(Flits(data.item).find('.flits-product-card').hasClass('flits-wishlist-card')){
//       if(!data.status){
//         console.log("Wishlist Data Added..!")
//         var itemDom = data.item;	
//         var product = flitsGetProductDetailsFromWishlistResponse(data.handle);
//         let image = "https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif";
//         product.product_image != null && (image = product.product_image);
//         let extidx = image.lastIndexOf(".");
//         let extension = image.substr(extidx);
//         (image = image.replace(extension, "_200x_crop_center" + extension)), Flits(itemDom).find(".flits-product-image img").attr("src", image);
//         let imgWidth = Flits(itemDom).find(".flits-product-image img").width();
//         let imgHeight = Flits(itemDom).find(".flits-product-image img").height();
//         imgWidth > imgHeight;
//         Flits(itemDom).find(".flits-floating-label label").html(product.product_title );
//         Flits(itemDom).find(".flits-product-price").html(Flits.formatMoney(Math.abs(0 * 100), Flits.money_format));
//         Flits(itemDom).find(".flits-product-price").css({
//           visibility:"hidden"
//         });
//         Flits(itemDom).find(".flits-floating-label").addClass("flits-without-select"),
//           Flits(itemDom).find(".flits-floating-label.flits-without-select").attr("data-tippy-content", product.product_title);
//         Flits(itemDom).find(".flits-floating-label .flits-variant-select").hide();
//         Flits(itemDom).find(".flits-floating-label label").attr("data-tippy-content", product.product_title );
//         Flits(itemDom).find(".flits-remove-product").attr("data-flits-product-id", product.product_id );
//         Flits(itemDom).find(".flits-remove-product").attr("data-flits-product-title", product.product_title);
//         Flits(itemDom).find(".flits-remove-product").attr("data-flits-product-handle", product.product_handle );
//         Flits(itemDom).find(".flits-add-to-cart").attr("data-remove", product.product_id);
//         let sold_out_text = Flits(itemDom).find(".flits-add-to-cart").attr("data-flits-sold-text");
//         Flits(itemDom).find(".flits-add-to-cart").addClass("flits-btn-danger");
//         Flits(itemDom).find(".flits-add-to-cart").attr("disabled", !0);
//         Flits(itemDom).find(".flits-add-to-cart").text(sold_out_text);
//         Flits(itemDom).find(".flits-product-quantity").addClass("flits-disabled");
//       }
//     }
//     else if(Flits(data.item).find('.flits-product-card').hasClass('flits-recently-view-card')){    
//       if(!data.status){
//         Flits(data.item).css("display","none")
//       }
//     }
//   });

//   function flitsGetProductDetailsFromWishlistResponse(handle){
//     var item_details = undefined;
//     Flits.each(window.flitswishlistResponse.data,function(index,item){
//       if(item.product_handle == handle){
//         item_details = item;
//         return false;
//       }
//     });
//     return item_details;
//   }     
          
//   Flits(window).on('Flits:Wishlist:Loaded', function(event){ 
//     setTimeout(function(){
//       document.querySelectorAll("p.flits-product-price-saving").forEach(e => {
//         if(e.innerText.length !== 0){
//           var text = e.innerText.split(" ");

//           e.innerText =   Flits.t("Flits.locals.recently_viewed_product_page.save", "Save") + " " + text[1];
// //           console.log(e.innerText.length);
//         }
//       } );
//     },2000);
//   });
  
  
  
  // STORE CREDIT
  Flits(window).on('Flits:CartAutomaticCode:Loaded', function(event){ 
    if(window.location.pathname === "/cart" || window.location.pathname === "/"){
      setTimeout(function(){
        Flits(".cart__checkout").replaceWith('<a type="submit" name="checkout" data-terms-required="false" class="btn cart__checkout" data-flits="store-credit-added">Procedi</a>');
      },1500);
    }
  });
  
  
if(location.pathname.indexOf("/account") != -1){
  Flits(document).on('click', '.flits-custom-tab-add', function(e){
    var elem = Flits(this).attr('href');
    var el = elem.replace('#', '');
    Flits('.flits-account-page-container').addClass('flits-active');
    Flits('.flits-nav-tabs .flits-menu-item').removeClass('flits-active');
    Flits('.flits-custom-tab-add').removeClass('flits-active');
    Flits('a[href="'+elem+'"]').parent().addClass('flits-active');
	Flits('.flits-tab-box').removeClass('flits-active');
    Flits('#flits_tab_'+el).addClass('flits-active');
  });
}
  if(Flits.customer_id != -1){
  window.isFirstTimePopup = false;
  if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
   window.isFirstTimePopup = true;
  var referfirstRegister = new flits_tingle.modal({
    footer: !1,
    stickyFooter: !1,
    getContent: !0,
    closeMethods: ["button"],
    closeLabel: "Close",
    cssClass: ["flits-tingle-modal-popup-container"],
    beforeClose: function () {
      return !0;
    },
  });
  Flits(document).on('Flits:myProfile:updateCustomerNote', function(event){
    var e_data =  event.detail.params;
    var val = event.detail.val;
    var customer_note = window.flits_exist_customer_note;
    if (customer_note === null){
      customer_note = customer_note ||  ""; 
    }
    //     var customer_notes = ['first_time_popup']; // add value into array to change/add into customer note
    var new_customer_note = customer_note;

    var item = "first_time_popup";
    if(customer_note.indexOf(item) == -1){

      new_customer_note += item + ": " + val +"\n";
    }else{
      if(customer_note != null){
        var all_note_data = customer_note.split('\n');
        Flits.each(all_note_data,function(index_i,item_i){
          if(item_i.indexOf(item) != -1){
            //             var item_old = item_i.replace(item_i, item);
            new_customer_note = new_customer_note.replace(item_i, item + ": " + val);
          }
        });
      }
    }
    e_data.push({"name":"customer_note","value":new_customer_note});      
  });

  Flits(".flits-custom-profile-form #flits-form-profile-custom").submit(function (event) {
    event.preventDefault();
    let form = Flits(this);
    let params = form.serializeArray();
    let indexGender = params.findIndex(function (data) {
      return data.name == "gender";
    });
//     if (params[indexGender].value == "none") {
//       params.splice(indexGender, 1);
//     }
//     let index = params.findIndex(function (data) {
//       return data.name == "phone";
//     });
//     let number = Flits('#flits-form-profile .flits-input[name="phone"]').val();
//     let country = Flits("#flits-form-profile .flits-profile-phone-with-country-div .flits-country-code-textbox").val();
//     if (number.length != 0) {
//       params[index].value = country + number;
//     }
    let url = Flits.base_url + "/" + Flits.customer_id + form.attr("action");
    let method = form.attr("method");
    params.push({ name: "customer_hash", value: Flits.customerHash }), params.push({ name: "token", value: Flits.token });
    Flits.dispatchEvent("Flits:myProfile:updateCustomerNote", { params: params,val:0 });
    Flits.ajax({ method: method, url: url, data: params })
    .done(function (resp) {
      if (resp.status) {
        Flits.setLocalStorage("is_first_time_popup",0,1);
      } else {
      }
    })
    .fail(function (resp) {})
    .always(function () {});
  });
  var get_first_time_popup_val = Flits.getLocalStorage("is_first_time_popup");
  if(Flits.isNull(get_first_time_popup_val) && Flits.customer_id != -1){
    let customer_note_url = Flits.base_url+'/'+Flits.customer_id + "/credit/get_credit";
    Flits.ajax({
      method: "get",
      url: customer_note_url,
      data: {
        customer_hash: Flits.customerHash,
        token: Flits.token
      },
    }).done(function(resp){ 
      if (resp.status) {          
        window.flits_exist_customer_note = resp.customer.note;
        if (window.flits_exist_customer_note !== null){
          var customer_note = window.flits_exist_customer_note;
          var item = 'first_time_popup:';
          if(customer_note.indexOf(item) != -1){
            var all_note_data = customer_note.split('\n');
            Flits.each(all_note_data,function(index_i,item_i){
              if(item_i.indexOf(item) != -1){              
                var note_val = item_i.replace(item ,"");
                var isFirstTimePopup = note_val.trim();

                if(isFirstTimePopup == 1){
                  let referModalContent = Flits("#flits-referral-modal-new-registered").clone();

                  var contentText = Flits.t("Flits.locals.general.refer_first_registerd_text", "Congratulazioni, sei dei nostri! Riceverai un'email con un coupon da 10€ da utilizzare per il tuo prossimo acquisto.");
                  Flits(referModalContent).find(".flits-refer-content").html(contentText), referfirstRegister.setContent(Flits(referModalContent).html()), referfirstRegister.open(), Flits.dispatchEvent("Flits:referFriendRegisterFirst:ModalOpen");               
                  window.isFirstTimePopup = true;
                  //                   updatecustomernote(0);
                  Flits(".flits-custom-profile-form #flits-form-profile-custom").submit();              
                }
              }
            });
          } else{
            Flits.setLocalStorage("is_first_time_popup",0);
          }
        }
      }
    }).fail(function(resp){
    }).always(function(){});
  }
  }
    
  Flits(document).on('Flits:AddressDefault:Click', function(event){
    var form = event.detail.item;
    var countryVal = form.find(".flits-address-phone-with-country-div .flits-country-code-textbox").val();
    if(!countryVal){
      Flits('.flits-address-card-action').removeClass('flits-disabled');
      flitsSnackbar.show({ text: Flits.t("Flits.locals.general.country_code_error_message", "Enter the prefix of your phone number"), pos: "bottom-center", showAction: !1, customClass: "flits-alert-danger", duration: 2400 });
    }
  });
  Flits(document).on('Flits:AddressSave:Click', function(event){
    var form = event.detail.item;
    var countryVal = form.find(".flits-address-phone-with-country-div .flits-country-code-textbox").val();
    if(!countryVal){
      flitsSnackbar.show({ text: Flits.t("Flits.locals.general.country_code_error_message", "Enter the prefix of your phone number"), pos: "bottom-center", showAction: !1, customClass: "flits-alert-danger", duration: 2400 });
    }
  });
  


  Flits(document).ready(function(){
    Flits(".footer__menu a[href='https://www.mysecretcase.com/it/account#wishlist']").attr("href","https://www.mysecretcase.com/account#wishlist");
  });
  
}(Flits));
